const AgentUnavailableUI = ({ name, source }) => {
  return (
    <div
      style={{
        width: "350px",
        height: "400px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        padding: "1.5rem",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
      }}
    >
      <p
        style={{
          fontSize: "1.25rem",
          fontWeight: "600",
          color: "#1F2937",
          marginBottom: -8,
        }}
      >
        Hi, {name} 👋
      </p>

      <h2
        style={{
          fontSize: "1.25rem",
          fontWeight: "600",
          color: "#1F2937",
          marginBottom: "0.75rem",
        }}
      >
        Thank you for reaching out to us!
      </h2>

      <p
        style={{
          color: "#6B7280",
          fontSize: "0.95rem",
          lineHeight: "1.5",
          marginBottom: "1rem",
          maxWidth: "280px",
        }}
      >
        Our{" "}
        {source === "Health_Insurance" ? "insurance agents" : "tax specialists"}{" "}
        are offline at the moment. We'll get back to you as soon as possible.
      </p>

      <p
        style={{
          color: "#4B5563",
          fontSize: "0.95rem",
          lineHeight: "1.5",
          maxWidth: "280px",
          fontWeight: "500",
          marginBottom: "1.5rem",
        }}
      >
        We appreciate your patience ✨.
      </p>

      {/* Tax-related waiting animation */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "0.5rem",
          position: "relative",
          width: "100px",
          height: "50px",
        }}
      >
        {/* Calculator icon */}
        <div
          style={{
            position: "absolute",
            left: "0",
            animation: "slideCalc 3s infinite",
            opacity: 0,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#3B82F6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="4" y="2" width="16" height="20" rx="2" />
            <line x1="8" x2="16" y1="6" y2="6" />
            <line x1="8" x2="8" y1="10" y2="10" />
            <line x1="12" x2="12" y1="10" y2="10" />
            <line x1="16" x2="16" y1="10" y2="10" />
            <line x1="8" x2="8" y1="14" y2="14" />
            <line x1="12" x2="12" y1="14" y2="14" />
            <line x1="16" x2="16" y1="14" y2="14" />
            <line x1="8" x2="8" y1="18" y2="18" />
            <line x1="12" x2="12" y1="18" y2="18" />
            <line x1="16" x2="16" y1="18" y2="18" />
          </svg>
        </div>

        {/* Document icon */}
        <div
          style={{
            position: "absolute",
            left: "0",
            animation: "slideDoc 3s infinite",
            animationDelay: "1s",
            opacity: 0,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#16A34A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <line x1="10" y1="9" x2="8" y2="9" />
          </svg>
        </div>

        {/* Money icon */}
        <div
          style={{
            position: "absolute",
            left: "0",
            animation: "slideMoney 3s infinite",
            animationDelay: "2s",
            opacity: 0,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#CA8A04"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="6" width="20" height="12" rx="2" />
            <circle cx="12" cy="12" r="2" />
            <path d="M6 12h.01M18 12h.01" />
          </svg>
        </div>
      </div>

      {/* Animation keyframes */}
      <style>
        {`
            @keyframes slideCalc {
              0%, 100% { 
                opacity: 0;
                transform: translateX(0px);
              }
              10% { 
                opacity: 1;
              }
              40% { 
                opacity: 1;
                transform: translateX(80px);
              }
              50% { 
                opacity: 0;
                transform: translateX(100px);
              }
            }
            
            @keyframes slideDoc {
              0%, 100% { 
                opacity: 0;
                transform: translateX(0px);
              }
              10% { 
                opacity: 1;
              }
              40% { 
                opacity: 1;
                transform: translateX(80px);
              }
              50% { 
                opacity: 0;
                transform: translateX(100px);
              }
            }
            
            @keyframes slideMoney {
              0%, 100% { 
                opacity: 0;
                transform: translateX(0px);
              }
              10% { 
                opacity: 1;
              }
              40% { 
                opacity: 1;
                transform: translateX(80px);
              }
              50% { 
                opacity: 0;
                transform: translateX(100px);
              }
            }
          `}
      </style>
    </div>
  );
};

export default AgentUnavailableUI;
